import React, { useEffect } from 'react';
import InfiniteScroller from 'react-infinite-scroller';

import sleep from '@/utils/sleep';

interface Props {
  children: React.ReactNode;
  loadMore: () => void;
  hasMore: boolean;
  useWindow?: boolean;
  loader: React.ReactNode;
  loading: boolean;
  threshold?: number;
  initialLoad?: boolean;
}

function InfiniteScroll({
  children,
  loadMore,
  hasMore,
  loader,
  loading,
  useWindow = false,
  threshold = 250,
  initialLoad = false,
}: Props): React.ReactElement {
  const [timeOut, setTimeout] = React.useState(false);
  const wait = async (): Promise<void> => {
    setTimeout(true);
    await sleep(5);
    setTimeout(false);
  };
  useEffect(() => {
    !loading && wait();
  }, [loading]);
  // The page scrolls inside #root, not the window: global-style.scss gives
  // html/body/#root `height: 100%` together with `overflow-x: hidden`, and the
  // browser then computes `overflow-y: auto` on #root. Callers passing
  // `useWindow` mean "scroll with the page", so point the scroller at that
  // element instead of the window, which never emits a scroll event here.
  const getScrollParent = useWindow
    ? (): HTMLElement | null => document.getElementById('root')
    : undefined;
  return (
    <InfiniteScroller
      initialLoad={initialLoad}
      pageStart={0}
      useWindow={false}
      getScrollParent={getScrollParent}
      loadMore={() => !loading && loadMore()}
      hasMore={!timeOut && hasMore}
      loader={loader}
      threshold={threshold}
    >
      {children}
    </InfiniteScroller>
  );
}

export default InfiniteScroll;
